/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SkipNext/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function SkipNext({
  children,
  viewPath = "/App/Auth/SignIn/TwoFactorAuth/SkipNext",
  onChange
  
}) {
let signinMfaSkipNextValueData = fromData.useDataValue({ viewPath,
context: 'signin',
path: 'mfa.skip_next',
})
let signinMfaSkipNextChangeData = fromData.useDataChange({ viewPath,
context: 'signin',
path: 'mfa.skip_next',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="signin.mfa.skip_next"
 onChange={signinMfaSkipNextChangeData}
 value={signinMfaSkipNextValueData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="remember this browser for the next 30 days"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}